import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IState {
	isFaceBookTypeModal: boolean;
	isFaceBookPageModalOpen: boolean;
}

const initialState: IState = {
	isFaceBookTypeModal: false,
	isFaceBookPageModalOpen: false,
};

export const modalSlice = createSlice({
	name: "modalSlice",
	initialState,
	reducers: {
		faceBookTypeModalOpen: (state: any, action: PayloadAction<boolean>) => {
			state.isFaceBookTypeModal = action.payload;
		},
		faceBookPageModalOpen: (state: any, action: PayloadAction<boolean>) => {
			state.isFaceBookPageModalOpen = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { faceBookTypeModalOpen, faceBookPageModalOpen } = modalSlice.actions;

export default modalSlice.reducer;
